<section class="hero is-link is-small">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        <span class="icon-text">
          <span class="icon"><i class="fa-solid fa-toggle-on" aria-hidden="true"></i></span>
          <span>Browse Propositions</span>
        </span>
      </h1>
    </div>
  </div>
</section>

<section class="section container" data-propositions-content></section>
